/**
 * BolsaDeProfissionais.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RegimeTrabalhoEnum = 1 | 2 | 3 | 4;

export const RegimeTrabalhoEnum = {

    NUMBER_1: 1 as RegimeTrabalhoEnum,

    NUMBER_2: 2 as RegimeTrabalhoEnum,

    NUMBER_3: 3 as RegimeTrabalhoEnum,

    NUMBER_4: 4 as RegimeTrabalhoEnum
};

